var React = require('react');

function DividerVertical1 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0,0 L100,0 L100,100 L0,100 C66.6666667,83.3333333 100,66.6666667 100,50 C100,33.3333333 66.6666667,16.6666667 0,0 Z","fill":"#ffffff"}));
}

DividerVertical1.defaultProps = {"viewBox":"0 0 100 100","preserveAspectRatio":"none","width":"100%","height":"100%","version":"1.1"};

module.exports = DividerVertical1;

DividerVertical1.default = DividerVertical1;
